"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NAMES_PRODUCT_NAME = exports.NAMES_BRAND_NAME = exports.NAMES = void 0;
const NAMES = exports.NAMES = 'names';
const NAMES_BRAND_NAME = exports.NAMES_BRAND_NAME = 'names-brand-name';
const NAMES_PRODUCT_NAME = exports.NAMES_PRODUCT_NAME = 'names-product-name';
